<template></template>
<script>
  export default {
    data: function () {
      return {
        content: `
# 自我介绍

> 我叫王永庆，是一名WEB开发工程师

> 参与过多个项目开发，有比较丰富的项目经验（包括手机WEB、后台管理、API接口、H5、服务器运维）

> 作为核心的程序员，在项目中进行 需求分析、数据库设计、接口设计、后台管理升级、业务代码开发 等工作

> 涉及技术点比较丰富，使用缓存、RPC服务、消息队列服务等技术，不仅提高了程序的性能而且进行业务的解耦

> 喜欢新技术的尝试和挑战，并且有较强的专业技术，能够与同事和谐相处

---

# 联系方式

- 手机：15150420620
- Email：1045643440@qq.com

---

# 个人信息

 - 男/1989
 - 本科/数学与应用数学专业
 - 工作年限：7年（2012-09 - 2018-08）
 - 技术博客：http://itman.su520.com
 - Github：https://github.com/jasonyqwang
 - 期望职位：高级PHP开发工程师、前端开发工程师
 - 期望薪资：面谈
 - 期望城市：苏州 | 上海

---

# 工作经历
### 鹰空网络科技有限公司 （ 2018年08月 ~ 今 ）

- 全栈工程师
- 1.基于Laravel 的游戏，小说、视频等后台搭建
- 2.基于Vue的H5项目开发
- 3.基于Redis、Mysql、SSDB做数据存储的数据库设计
- 4.基于Composer开发，接口以及SDK插件的开发

### 梦嘉传媒有限公司 （ 2017年12月 ~ 2018-08 ）

- 超级头条项目（PHP主管）
- 1.团队管理与沟通工作
- 2.负责团队成员的任务分配，需求评估工作
- 3.超级头条项目的整体架构设计
- 4.广告系统、采集系统、接口系统、以及裂变系统的设计，以及开发
- 5.兼顾一部分运维工作

### 微邦财务咨询有限公司（ 2014年2月 ~ 2017-12 ）

- 掌知识项目（组长）
- 1.后台以及接口架构设计，协作分配团队任务
- 2.需求分析，数据库设计
- 3.编写核心业务代码，实现功能
- 4.发布代码，承担一部分运维工作

### 功夫网络科技有限公司（ 2012年9月 ~ 2014-01 ）

- 功夫信项目
- 1.功夫信是关于校园招聘的项目
- 2.集成 求职者、公司管理员、公司HR、系统管理、网站首页，投票等功能模块
- 3.项目引入Redis、推送、搜索引擎、JqueryMobile 等技术

# 技能清单

以下均为我熟练使用的技能

- Web开发：PHP/Javascript/Nodejs
- Web框架：Yii/Laravel/ThinkPHP/Yaf
- 前端框架：Layui/Bootstrap/HTML5/Vue
- 前端工具：Webpack/SaSS
- 数据库相关：MySQL/Redis/MongoDB/Memcache
- 版本管理、文档和自动化部署工具：Svn/Git/Composer/Docker/Jenkins
- 云平台：Aliyun/SAE/AWS

---

# 致谢
感谢您花时间阅读我的简历，期待能有机会和您共事。


        `
      }
    }
  }

  console.log('===================================================')

  console.log('===============  目前对外公开访问的项目 =====================')

  console.log('2017-2018 http://android.myapp.com/myapp/detail.htm?apkName=com.moka.cjtt')

  console.log('2014-2017： http://www.microbenefits.com/   http://www.ifuli.cn')

  console.log('2015:  PC - http://maimwu.com   Phone - http://m.maimwu.com/')

  console.log('2013:  http://www.job123.jp')

  console.log('===================================================')
</script>



// WEBPACK FOOTER //
// ResumeContent.vue?3321220e